import axios from '../utils/axios'

// 商品详情
export function SaleProductInfo(params) {
  return axios({
    url: '/NoAuth/SaleIndex/SaleProductInfo',
    method: 'get',
    params: params
  })
}

// 立即搜货
export function SoHo(data) {
  return axios({
    url: '/Sale/Task/SoHo',
    method: 'post',
    data: data
  })
}

// 关键词反馈
export function NotFindKeyFeedback(data) {
  return axios({
    url: '/Sale/Task/NotFindKeyFeedback',
    method: 'post',
    data: data
  })
}

// 关键词第二次反馈
export function SecondNotFindKeyFeedback(data) {
  return axios({
    url: '/Sale/Task/SecondNotFindKeyFeedback',
    method: 'post',
    data: data
  })
}

// 获取关键词倒计时时间
export function KeyRelationTimeGet(params) {
  return axios({
    url: '/Sale/Task/KeyRelationTimeGet',
    method: 'get',
    params: params
  })
}

// 验证淘宝口令
export function SaleTaskApply(data) {
  return axios({
    url: '/Sale/Task/SaleTaskApply',
    method: 'post',
    data: data
  })
}

// 拼多多验证商品链接
export function PddSaleTaskApply(data) {
  return axios({
    url: '/Sale/Task/PddSaleTaskApply',
    method: 'post',
    data: data
  })
}

// 京东验证商品链接
export function JdSaleTaskApply(data) {
  return axios({
    url: '/Sale/Task/JdSaleTaskApply',
    method: 'post',
    data: data
  })
}

// 开启上架提醒
export function ProductRemindAdd(data) {
  return axios({
    url: '/Sale/Task/ProductRemindAdd',
    method: 'post',
    data: data
  })
}

// 关闭上架提醒
export function ProductRemindCancel(data) {
  return axios({
    url: '/Sale/Task/ProductRemindCancel',
    method: 'post',
    data: data
  })
}

// 免搜商品详情（未登录）
export function GetTBKProductInfoNoLogin(params) {
  return axios({
    url: '/NoAuth/TBKProduct/GetTBKProductInfo',
    method: 'get',
    params: params
  })
}

// 免搜商品详情（已登录）
export function GetTBKProductInfoLogin(params) {
  return axios({
    url: '/SaleV2/TBKProduct/GetTBKProductInfo',
    method: 'get',
    params: params
  })
}

// 免搜获取优惠券淘口令（已登录）
export function GetCouponTKLWord(params) {
  return axios({
    url: '/SaleV2/TBKProduct/GetCouponTKLWord',
    method: 'get',
    params: params
  })
}

// 免搜获取优惠券淘口令（未登录）
export function GetCouponTKLWordNoLogin(params) {
  return axios({
    url: '/NoAuth/TBKProduct/GetCouponTKLWord',
    method: 'get',
    params: params
  })
}

// 免搜价格出错
export function FeedbackTkError(params) {
  return axios({
    url: '/SaleV2/TBKProduct/FeedbackTkError',
    method: 'get',
    params: params
  })
}

// 第三步获取价格区间
export function OrderStep3InfoGet(params) {
  return axios({
    url: '/Sale/Task/OrderStep3InfoGet',
    method: 'get',
    params: params
  })
}

// 是否存在订单
export function CheckIsExistSOrder(data) {
  return axios({
    url: '/Sale/Task/CheckIsExistSOrder',
    method: 'post',
    data: data
  })
}

// 基础销量模式第一步数据
export function PddBaseSaleModelOrderStep1InfoGet(params) {
  return axios({
    url: '/Sale/Task/PddBaseSaleModelOrderStep1InfoGet',
    method: 'get',
    params: params
  })
}

// 判断收藏夹商品是否可购买接口
export function IsBuy(params) {
  return axios({
    url: '/SaleV2/ProductFavorite/IsBuy',
    method: 'get',
    params: params
  })
}

// 获取提醒列表商品接口
export function GetProductPrePurchaseRemindList(params) {
  return axios({
    url: '/SaleV2/ProductFavorite/GetProductPrePurchaseRemindList',
    method: 'get',
    params: params
  })
}
